<div>
  <div class="flex justify-between relative flex-col">
    <div class="toolbar bg-primary flex items-center justify-between px-1">
      <mat-tab-group
        (selectedIndexChange)="onTabChange($event)"
        [selectedIndex]="currentTab"
        class="orders-tabs"
      >
        <mat-tab label="ACTIVE ORDERS"></mat-tab>
        <mat-tab label="ARCHIVED ORDERS"></mat-tab>
        <mat-tab label="ALL ORDERS"></mat-tab>
        <mat-tab label="SAVED LISTS"></mat-tab>
      </mat-tab-group>

      @if (!isSavedLists()) {
        <mat-form-field>
          <mat-label class="text-white text-sm">Search orders</mat-label>
          <input matInput [formControl]="searchControl" />
        </mat-form-field>
      }
    </div>
    @if (!isSavedLists() && !isEditPage()) {
      <div class="filters-container flex gap-4 py-4 items-center">
        <button
          mat-flat-button
          type="button"
          (click)="openAddModal()"
          class="!bg-green-600 !text-white rounded-none shadow-md"
        >
          CREATE LIST +
        </button>
        <mat-form-field class="flex-1">
          <mat-label>Filter by User</mat-label>
          <mat-select [formControl]="userFilterControl">
            @for (option of assignees(); track option.id) {
              <mat-option [value]="option.id">
                {{ option.firstName }} {{ option.lastName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="flex-1">
          <mat-label>Filter by Status</mat-label>
          <mat-select [formControl]="statusFilterControl">
            @for (option of statuses(); track option.key) {
              <mat-option [value]="option.key">{{ option.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="flex-1">
          <mat-label>Filter by Assignee</mat-label>
          <mat-select [formControl]="assigneeFilterControl">
            @for (option of assignees(); track option.id) {
              <mat-option [value]="option.id"
                >{{ option.firstName }} {{ option.lastName }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>From</mat-label>
          <input
            matInput
            [matDatepicker]="fromPicker"
            [formControl]="fromDateControl"
            placeholder="Choose a date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>To</mat-label>
          <input
            matInput
            [matDatepicker]="toPicker"
            [formControl]="toDateControl"
            placeholder="Choose a date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="filter-by-date flex justify-end gap-4"></div>
      <div class="flex justify-end gap-2 pb-4">
        <button mat-flat-button color="primary" (click)="onClearFilters()">Clear Filters</button>
      </div>
    }
  </div>

  <router-outlet></router-outlet>
</div>
